import type { GameDefinition, GameId } from './core/types';
import { gameCatalog } from './catalog';
import { ClambersEntry } from './clambers/ClambersEntry';
import { ChromalEntry } from './chromal/ChromalEntry';
import { FixtureGame } from './fixture/FixtureGame';
import { MiniSudokuEntry } from './mini-sudoku/MiniSudokuEntry';
import { MinesweeperEntry } from './minesweeper/MinesweeperEntry';
import { MiniCrosswordEntry } from './mini-crossword/MiniCrosswordEntry';
import { NonogramEntry } from './nonogram/NonogramEntry';
import { PaireEntry } from './paire/PaireEntry';
import { QueensEntry } from './queens/QueensEntry';
import { RatioleEntry } from './ratiole/RatioleEntry';
import { ShapeupEntry } from './shapeup/ShapeupEntry';
import { WordyGame } from './wordy/WordyGame';

export const gameRegistry = new Map<GameId, GameDefinition>(
  gameCatalog.map((definition) => [
    definition.id,
    {
      ...definition,
      Component:
        definition.id === 'wordy'
          ? WordyGame
          : definition.id === 'mini-crossword'
            ? MiniCrosswordEntry
            : definition.id === 'clambers'
              ? ClambersEntry
              : definition.id === 'chromal'
                ? ChromalEntry
                : definition.id === 'ratiole'
                  ? RatioleEntry
                  : definition.id === 'shapeup'
                    ? ShapeupEntry
                    : definition.id === 'mini-sudoku'
                      ? MiniSudokuEntry
                      : definition.id === 'minesweeper'
                        ? MinesweeperEntry
                        : definition.id === 'queens'
                          ? QueensEntry
                          : definition.id === 'nonogram'
                            ? NonogramEntry
                            : definition.id === 'paire'
                              ? PaireEntry
                              : FixtureGame,
    },
  ]),
);

export function getGameDefinition(gameId: GameId): GameDefinition {
  const definition = gameRegistry.get(gameId);
  if (!definition) throw new Error(`Unknown game: ${gameId}`);
  return definition;
}
